import { Theme, styled } from "@mui/material/styles";

import { Box } from "@mui/material";

export const NotificationCardContainerStyle = (theme: Theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
});

// Shared card "chrome" (radius, border, background, shadow, hover) used by both
// the classic notification card and the full-bleed Braze content card so the
// two do not drift.
const cardChrome = (theme: Theme) => ({
  "borderRadius": "8px",
  "background": "#FFF",
  "border": `1px solid ${theme.palette.sand.main}`,
  "boxShadow": "0px 4px 12px rgba(0, 0, 0, 0.1)",
  "transition": "all 0.3s ease",
  "cursor": "pointer",
  "&:hover": {
    transform: "scale(0.97)",
    boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.1)",
  },
});

export const NotificationCards = styled(Box)(({ theme })=>({
  ...cardChrome(theme),
  "display": "flex",
  "padding": "1rem 12px 1rem 1rem",
  "alignItems": "flex-start",
  "gap": "22px",
}));

// Full-bleed Braze content card (captioned / image-only): same chrome as the
// classic card, but stacked so the image sits above the text block.
export const BrazeFullCard = styled(Box)(({ theme })=>({
  ...cardChrome(theme),
  "display": "flex",
  "flexDirection": "column",
  "overflow": "hidden",
}));

export const NotificationInnerStyle = (theme: Theme) =>({
  "display": "flex",
  "flexDirection": "column",
  "gap": "4px",
  "position": "relative",
  "transition": "all 0.3s ease",
});

// "Pinned" badge pinned to the top-right corner of a card. It overlays the
// card (absolute) so it never pushes layout, and the consuming card reserves
// space on the first content row so the badge never clips text.
export const PinnedBadge = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "8px",
  right: "8px",
  zIndex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "4px",
  padding: "4px 6px",
  borderRadius: "4px",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.warning.main,
  fontSize: "11px",
  lineHeight: "normal",
  fontWeight: 500,
  pointerEvents: "none",
  whiteSpace: "nowrap",
}));

export const NotificationUnreadDot = styled(Box)(({ theme })=>({
  position: "absolute",
  top: "3px",
  right: "0",
  width: "10px",
  height: "10px",
  borderRadius: "50%",
  backgroundColor: theme.palette.primary.main,
}));

export const NullContainerBox = styled(Box)(({ theme }) => ({
  "display": "flex",
  "padding": "32px 12px 32px 16px",
  "alignItems": "flex-start",
  "gap": "22px",
  "alignSelf": "stretch",
  "borderRadius": "8px",
  "border": "1px solid #F4EFEB",
  "background": "#FFF",
  "backdropFilter": "blur(7.5px)",
  ".nullContent": {
    "display": "flex",
    "flexDirection": "column",
    "gap": "20px",
    "alignItems": "center",
    "justifyContent": "center",
    "textAlign": "center",
    "width": "100%",
    ".nullText": {
      width: "75%",
      marginLeft: "auto",
      marginRight: "auto",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
  },
}));

